import { render, staticRenderFns } from "./dangerRegularCheck.vue?vue&type=template&id=7effb380"
import script from "./dangerRegularCheck.vue?vue&type=script&lang=js"
export * from "./dangerRegularCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7effb380')) {
      api.createRecord('7effb380', component.options)
    } else {
      api.reload('7effb380', component.options)
    }
    module.hot.accept("./dangerRegularCheck.vue?vue&type=template&id=7effb380", function () {
      api.rerender('7effb380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerRegularCheck.vue"
export default component.exports